import { MenuInfo } from "data";
import { Navigate, Route, Routes } from "react-router-dom";
import { MonitoringLayout } from "layout/monitoring";
import MonitoringSettingRoutes from "./setting/MonitoringSettingRoutes";
import usePermission from "hooks/usePermission";
import RouteAccessError from "pages/RouteAccessError";

export default function MonitoringRoutes() {
    const monitoringMenu = MenuInfo.CMMS;
    const setting = MenuInfo.CMMS_MANAGEMENT;   // 관리

    const { hasPermission, isPermissionReady } = usePermission();
    // console.log(isPermissionReady)
    if (!isPermissionReady) {
        return null;
    }
    const visibleMenus = monitoringMenu.children.filter(menu => {
        const permissionOk =
            !menu.permission || hasPermission(menu.permission);

        const featureOk =
            menu.feature === undefined || menu.feature;

        return permissionOk && featureOk;
    });
    // console.log(visibleMenus)

    const settingVisible =
        (!setting.permission || hasPermission(setting.permission)) &&
        (setting.feature === undefined || setting.feature);

    return (
        <Routes>
            <Route path="/*" element={ <MonitoringLayout/> }>
                <Route path="/*" element={ <Navigate to={visibleMenus[0]?.path} replace /> }/>
                {
                    visibleMenus.map(child => {
                        return (
                            <Route key={child.id} path={child.path + (child.isMultiPageMenu ? '/*' : '')} element={ child.element }/>
                        );
                    }) 
                }

                {settingVisible && (
                    <Route path={setting.path + '/*'} element={ 
                        <MonitoringSettingRoutes/>
                    } />
                )}

                <Route path="*" element={ <RouteAccessError /> }/>
            </Route>
            
        </Routes>
    );
}